import { createAction, props } from '@ngrx/store';
import { DownloadDocumentEntity } from './download-document.models';

export const initDownloadData = createAction(
  '[Download Document Component] Get Download Data',
  props<{ categoryId: number; documentId: number }>()
);

export const clearDownloadDocuments = createAction('[Download Document Component] Clear Download Data');

export const loadDownloadDataSuccess = createAction(
  '[Download Document API] Load Download Data Success',
  props<{ documents: DownloadDocumentEntity[] }>()
);

export const loadDownloadDataFailure = createAction(
  '[Download Document API] Load Download Data Failure',
  props<{ error: string }>()
);
